import { MessageType } from '@agent/agent-interface/contact-view/social-network/model/message-type';

import { Booking, Customer } from '@contact/upgrade';

import { SocialNetworkMessage } from './social-network-message';
import { SocialNetworkTab } from './social-network-tab';

export class SocialNetworkModel {
  public customerId: string;
  public messages: Array<SocialNetworkMessage> = [];
  public tab: SocialNetworkTab;
  public isNew: boolean = true;
  public responseId: string;
  public threadId: string;
  public inPostTreatmentMode: boolean = false;
  public inPostTreatmentExceededMode: boolean = false;
  public postTreatmentBeforeDeadlineTime: number;
  public hasPostTreatment: boolean = false;
  public beginPostTreatment: number;
  public socialNetworkTabState: string = 'social-network';

  constructor(customerId: string, contact: Booking, customer: Customer | undefined) {
    this.customerId = customerId;
    this.threadId = contact.context['dimelo_thread_id'];
    if (!!customer) {
      this.messages.push(
        new SocialNetworkMessage(
          MessageType.SOCIAL_NETWORK,
          contact.context['dimelo_content'],
          customer.lastname,
          customer.firstname,
          undefined,
          contact.context['dimelo_date']
        )
      );
    } else {
      this.messages.push(
        new SocialNetworkMessage(MessageType.SOCIAL_NETWORK, contact.context['dimelo_content'], '', '', contact.context['dimelo_date'])
      );
    }
    this.hasPostTreatment = true;
    this.tab = SocialNetworkTab.fromSocialNetwork(this, contact);
  }

  public addMessage(msg: SocialNetworkMessage) {
    this.messages.push(msg);
    this.tab.updateSocialNetworkTabInfo(msg);
  }

  public increaseUnreadCount() {
    this.tab.increaseUnreadCount();
  }

  public resetUnreadCount() {
    this.tab.resetUnreadCount();
  }

  public updateNameContact(name: string) {
    this.tab.updateNameContact(name);
  }

  public computePostTreatmentValues(startTime: number, duration: number) {
    this.postTreatmentBeforeDeadlineTime = startTime + duration;
  }

  public postTreatmentDurationExceeded(currentTime: number) {
    return currentTime > this.postTreatmentBeforeDeadlineTime;
  }
}
